import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  Create,
  SimpleForm,
  TextInput,
  TopToolbar,
  ListButton,
  required,
  maxLength,
  AutocompleteInput,
  SelectInput,
  AutocompleteArrayInput,
} from 'react-admin';
import { Grid } from '@mui/material';
import CreateToolBar from '../../../components/commons/createToolBar';
import FUNC from '../../../utils/functions';
import canAccess from '../../../utils/canAccess';
import SemesterSelectInput from '../../../components/subject/subjectClasses/SemesterSelectInput';

export default React.memo(() => {
  const {
    types,
    teachers,
    scholastics,
    subjects,
  } = useSelector((state: any) => state.subjectClasses);

  const { permissions } = useSelector((state: any) => state.app.appState);

  const canAdd = canAccess(permissions, FUNC.ADD_SUBJECT_CLASS);
  const canSearch = canAccess(permissions, FUNC.SEARCH_SUBJECT_CLASSES);

  return (
    <Create
      actions={(
        <TopToolbar>
          {canSearch && <ListButton />}
        </TopToolbar>
      )}
    >
      <SimpleForm toolbar={<CreateToolBar isSave={canAdd} />}>
        <Grid container paddingX={12} spacing={2} rowSpacing={0.5}>
          <Grid item xs={12} md={4}>
            <SelectInput
              source="scholasticId"
              choices={scholastics ?? []}
              emptyValue=""
              fullWidth
              optionText={(choice) => choice.name}
              variant="outlined"
              helperText={false}
              validate={
                required()
              }
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <SemesterSelectInput
              source="semesterId"
              emptyValue=""
              fullWidth
              variant="outlined"
              helperText={false}
              validate={
                required()
              }
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <SelectInput
              source="subjectId"
              choices={subjects ?? []}
              emptyValue=""
              fullWidth
              optionText={(choice) => choice.name}
              variant="outlined"
              helperText={false}
              validate={
                required()
              }
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextInput
              source="name"
              fullWidth
              variant="outlined"
              helperText={false}
              validate={[
                required(),
                maxLength(100),
              ]}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextInput
              fullWidth
              variant="outlined"
              source="code"
              validate={[
                required(),
                maxLength(10),
              ]}
              helperText={false}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <SelectInput
              source="type"
              choices={types ?? []}
              emptyValue=""
              fullWidth
              optionText={(choice) => choice.name}
              variant="outlined"
              helperText={false}
              validate={
                required()
              }
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <AutocompleteInput
              source="teacherId"
              choices={teachers ?? []}
              emptyValue=""
              fullWidth
              optionText={(choice) => choice.name}
              variant="outlined"
              helperText={false}
              validate={
                required()
              }
            />
          </Grid>
          <Grid item xs={12} md={8} />
          <Grid item xs={12} md={4}>
            <AutocompleteArrayInput
              source="subTeacherIds"
              choices={teachers ?? []}
              emptyValue=""
              fullWidth
              optionText={(choice) => choice.name}
              variant="outlined"
              helperText={false}
              validate={
                required()
              }
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
});
